export default __webpack_public_path__ + "static/media/info-svg.f2da964f.svg";